import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { DASHBOARD_TEMPLATE_EVENTS } from "../../constants/DashboardTemplatesConstants";
import { SectionOfDashboard } from "../../models/SectionOfDashboard";
import DashboardFilterGroup from "../DashboardFilterGroup/DashboardFilterGroup.vue";

@Component({
  name: "FiltersModal",
  components: { DashboardFilterGroup },
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard",
      eventChart: "getEventChart"
    })
  }
})
export default class FilterSectionModal extends Vue {
  @Prop() indexSection!: number;
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;
  sectionWithFilters: SectionOfDashboard = {} as SectionOfDashboard;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;

  mounted() {
    this.sectionWithFilters = this.sectionsOfDashboardStore[this.indexSection];
  }

  cancelFilter() {
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.CANCEL_FILTER_SECTION);
  }
  saveFilter() {
    this.$emit(DASHBOARD_TEMPLATE_EVENTS.SAVE_FILTER_SECTION);
  }
}
